// extracted by mini-css-extract-plugin
module.exports = {"SectionA4":"SectionA4_SectionA4__PnVMP"};